var map = {
	"./icon-call": 2,
	"./icon-call.svg": 2,
	"./icon-cog": 3,
	"./icon-cog.svg": 3,
	"./icon-date": 4,
	"./icon-date.svg": 4,
	"./icon-dial-icon": 5,
	"./icon-dial-icon.svg": 5,
	"./icon-keyword-search": 6,
	"./icon-keyword-search.svg": 6,
	"./icon-phone-inbound": 7,
	"./icon-phone-inbound.svg": 7,
	"./icon-phone-outbound": 8,
	"./icon-phone-outbound.svg": 8,
	"./icon-time": 9,
	"./icon-time.svg": 9,
	"./icon-transcribe": 10,
	"./icon-transcribe.svg": 10,
	"./icon-user": 11,
	"./icon-user.svg": 11,
	"./remember-favicon": 12,
	"./remember-favicon.png": 12,
	"./remember-logo": 13,
	"./remember-logo-full": 0,
	"./remember-logo-full.png": 0,
	"./remember-logo-full.svg": 23,
	"./remember-logo.svg": 13
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22;